import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

@Pipe({
  name: 'filterBy',
  standalone: true
})
export class FilterByPipe implements PipeTransform {
  transform<T>(input: T[], props: (keyof T)[], search: unknown = '', strict = false): T[] {
    if (!Array.isArray(input)) {
      return input;
    }

    const searchString = String(search).toLowerCase().trim();

    return input.filter((obj) => {
      return props.some((prop) => {
        const value = get(obj, prop);

        if (!value) {
          return false;
        }

        const strValue = String(value).toLowerCase().trim();

        return strict ? strValue === searchString : strValue.includes(searchString);
      });
    });
  }
}
